import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
// import vrsg from '@vaersaagod/tools/vrsg';

export default (el, props) => {
    const dom = $(el);
    const closeButton = dom.find('[data-close]');

    const onClose = e => {
        e.preventDefault();
        $('html').addClass('had-alert-bar');
        $('html').removeClass('has-alert-bar');
        window.vrsg.setCookie(`hidealert-${props.id}`, '1', 30);

        setTimeout(() => {
            dom.remove();
            $('html').removeClass('had-alert-bar');
        }, 1000);
    };

    const init = () => {
        closeButton.on('click', onClose);
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/AlertBar.js